module.exports = __webpack_public_path__ + "assets/img/sabc_lineup_captain.webp?df3900b81383490887033afc6cebdd6b";